import { styled } from "@mui/material/styles";

export const BadgeContainer = styled("div")`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
`;

export const CardBodySection = styled("div")<{ borderColor?: string; spacing?: string | number }>(props => ({
  display: "flex",
  flexDirection: "column",
  gap: props.spacing ?? "1.5rem",
  borderBottom: `1px solid ${props.borderColor ?? "#e4e4e4"}`,
  padding: "15px 0",

  "&:empty": {
    display: "none",
  },
}));
